// src/services/HomePage/LabService.js

import axios from "axios";

// ✅ .env se URL lega
const BASE_URL = process.env.REACT_APP_API_URL || 'https://admintest.medrphalabs.com/api/';
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || 'https://admintest.medrphalabs.com/';

/* ================= Get LIVE Location ================= */
const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      console.error("❌ Geolocation not supported");
      reject("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        console.log("📍 LIVE Location:");
        console.log("Latitude :", lat);
        console.log("Longitude:", lng);

        resolve({ lat, lng });
      },
      (err) => {
        console.error("❌ Location permission denied:", err.message);
        reject("Location permission denied");
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  });
};

/* ================= Nearby Labs ================= */
export const fetchNearbyLabsData = async (latitude, longitude) => {
  try {
    console.log("📡 API call with:", latitude, longitude);

    const response = await axios.get(`${BASE_URL}Lab/nearbyStores`, {
      params: {
        latitude: Number(latitude),
        longitude: Number(longitude),
      },
    });

    console.log("📦 FULL RESPONSE 👉", response.data);

    // 🔥 IMPORTANT FIX
    let labsData = [];

    if (Array.isArray(response.data)) {
      labsData = response.data;
    } else if (Array.isArray(response.data?.data)) {
      labsData = response.data.data;
    } else {
      console.warn("⚠️ Unexpected API format");
      return [];
    }

    console.log("✅ FINAL LABS ARRAY 👉", labsData);

    return labsData.map((lab) => {
      let imageUrl = "https://placehold.co/400x250?text=No+Image";

      if (lab.lab_image?.trim()) {
        const clean = lab.lab_image.trim().replace(/\s/g, "%20");
        // ✅ ENV se image URL
        imageUrl = `${IMAGE_BASE_URL}LabImage/${clean}`;
      }

      return {
        id: lab.id,
        name: lab.lab_name,
        description: lab.description,
        address: lab.address,
        latitude: Number(lab.latitude),
        longitude: Number(lab.longnitude),
        distanceKm: lab.distanceKm,
        image: imageUrl,
        isActive: lab.isActive,
      };
    });

  } catch (error) {
    console.error("❌ API ERROR:", error);
    return [];
  }
};

/* ================= UI SAFE FUNCTION (FINAL FIX) ================= */
export const fetchLabsData = async () => {
  try {
    let lat = null;
    let lng = null;

    // ✅ Try to get location (optional)
    try {
      const location = await getCurrentLocation();
      lat = location.lat;
      lng = location.lng;
    } catch (err) {
      console.warn("⚠️ Location not available, using fallback API");
    }

    // ✅ Case 1: If location exists → nearby API
    if (lat && lng) {
      const nearby = await fetchNearbyLabsData(lat, lng);

      // ✅ FIX 3: fallback if empty
      if (nearby && nearby.length > 0) {
        return nearby;
      }

      console.warn("⚠️ Nearby empty → fallback to all labs");
    }

    // ✅ Case 2: Fallback API (NO location required)
    const response = await axios.get(`${BASE_URL}Lab/nearbyStores`);

    console.log("📦 FALLBACK RESPONSE 👉", response.data);

    const labsData =
      response.data?.data || response.data || [];

    if (!Array.isArray(labsData)) return [];

    const mapped = labsData
      .filter((lab) => lab.isLab && lab.isActive)
      .map((lab) => {
        let imageUrl = "https://placehold.co/400x250?text=No+Image+Available";

        if (lab.lab_image?.trim()) {
          const cleanName = lab.lab_image.trim().replace(/\s/g, "%20");
          // ✅ ENV se image URL
          imageUrl = `${IMAGE_BASE_URL}LabImage/${cleanName}`;
        }

        return {
          id: lab.id,
          name: lab.lab_name || "Unnamed Lab",
          description: lab.description || "No description",
          address: lab.address || "N/A",
          latitude: Number(lab.latitude),
          longitude: Number(lab.longnitude),
          distanceKm: lab.distanceKm,
          image: imageUrl,
          isActive: lab.isActive ?? true,
        };
      });

    console.log("✅ FALLBACK LABS 👉", mapped);

    return mapped;

  } catch (error) {
    console.error("❌ Cannot fetch labs:", error);
    return [];
  }
};